export default __webpack_public_path__ + "static/media/Menu_List.16c03eba.svg";